import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Dropdown.css';
import { usePermissoes } from '../utils/PermissoesContext';

export default function DropdownFinanceiro({ onLinkClick }) {
  const { temPermissao } = usePermissoes();
  
  return (
    <div className="dropdown-submenu-content">
      {temPermissao('Contrato') && <Link to="/sidebar/ContratoDropdown" onClick={onLinkClick}>Contrato</Link>}
      {temPermissao('ContasPagar') && <Link to="/sidebar/ContasPagarDropdown" onClick={onLinkClick}>Contas a Pagar</Link>}
      {temPermissao('ContasReceber') && <Link to="/sidebar/ContasReceberDropdown" onClick={onLinkClick}>Contas a Receber</Link>}

      {/* Nota Fiscal com sub-links */}
      {temPermissao('NotaFiscal') && (
        <div className="submenu-hover">
          <Link to="/sidebar/NotaFiscalDropdown" className="dropdown-main-item" onClick={() => { if (onLinkClick) onLinkClick(); }}>
            Nota Fiscal
          </Link>
          {temPermissao('CertificadoPlugNotas') && (
            <div className="dropdown-submenu-content">
              <Link to="/sidebar/CertificadoPlugNotasDropdown" onClick={onLinkClick}>
                🔐 Certificado Digital
              </Link>
            </div>
          )}
        </div>
      )}
      <Link to="/sidebar/GestaoFinanceiraDropdown" onClick={onLinkClick}>Gestão Financeira</Link>
    </div>
  );
}